import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogoMark } from '../components/Logo';

export default function SSOCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Completing sign-in...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      navigate('/login?sso_error=No+token+received', { replace: true });
      return;
    }
    loginWithToken(token)
      .then(() => {
        setStatus('Signed in! Redirecting...');
        navigate('/app', { replace: true });
      })
      .catch(() => {
        navigate('/login?sso_error=Session+setup+failed', { replace: true });
      });
  }, []);

  return (
    <div style={{ height: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 24 }}>
      <div style={{ width: 72, height: 72, position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, border: '2px solid transparent', borderTopColor: 'var(--j1)', borderRightColor: 'var(--j2)', borderRadius: '50%', animation: 'spin 1.2s linear infinite' }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <LogoMark size={40} />
        </div>
      </div>
      <div style={{ fontFamily: 'Share Tech Mono', fontSize: 12, color: 'var(--j1)', letterSpacing: 2 }}>{status}</div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
